import { sitePhrasing } from "../../../Language/languageHandler";
import TextInputField from "../../FormFields/TextInputField/TextInputField";
import { ContactInfoFields } from "./ContactInfoFields";
import NorthCarolinaPastDueAnnualReportFields from "./PastDueAnnualReport/NorthCarolinaPastDueAnnualReportFields";
import { AnnualReferenceNumberInstructions } from "./SharedPurchaseFieldComponents";

export const PastDueAnnualReportFields = (props: {
  errors: any;
  touched: any;
  values: any;
  selectedProducts: any;
  setFieldValue: any;
}) => {
  const {
    values,
    errors,
    touched,
    selectedProducts = {},
    setFieldValue,
  } = props;

  let annualPhrasing = "annual report";

  if (selectedProducts["amend"]) {
    annualPhrasing = "amendment";
  }

  if (selectedProducts["reinstate"]) {
    annualPhrasing = "reinstatement";
  }

  //   if (sitePhrasing.state === "Florida") {
  //     return (
  //       <FloridaAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         annualPhrasing={annualPhrasing}
  //         setFieldValue={setFieldValue}
  //         selectedProducts={selectedProducts}
  //       />
  //     );
  //   }

  //   if (sitePhrasing.state === "Georgia") {
  //     return (
  //       <GeorgiaAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         setFieldValue={setFieldValue}
  //         selectedProducts={selectedProducts}
  //       />
  //     )
  //   }

  //   if (sitePhrasing.state === "Indiana") {
  //     return (
  //       <IndianaAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         setFieldValue={setFieldValue}
  //         selectedProducts={selectedProducts}
  //       />
  //     );
  //   }

  //   if (sitePhrasing.state === "Mississippi") {
  //     return (
  //       <MississippiAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         setFieldValue={setFieldValue}
  //         selectedProducts={selectedProducts}
  //       />
  //     );
  //   }

  //   if (sitePhrasing.state === "Montana") {
  //     return (
  //       <MontanaAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         setFieldValue={setFieldValue}
  //         selectedProducts={selectedProducts}
  //       />
  //     );
  //   }

  if (sitePhrasing.state === "North Carolina") {
    return (
      <NorthCarolinaPastDueAnnualReportFields
        errors={errors}
        touched={touched}
        values={values}
        setFieldValue={setFieldValue}
        selectedProducts={selectedProducts}
      />
    );
  }

  //   if (sitePhrasing.state === "Tennessee") {
  //     return (
  //       <TennesseeAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         selectedProducts={selectedProducts}
  //         setFieldValue={setFieldValue}
  //       />
  //     );
  //   }

  //   if (sitePhrasing.state === "Virginia") {
  //     return (
  //       <VirginiaAnnualReportFields
  //         errors={errors}
  //         touched={touched}
  //         values={values}
  //         selectedProducts={selectedProducts}
  //         setFieldValue={setFieldValue}
  //       />
  //     );
  //   }


  return (
    <>
      <h3>Annual Report Questions for {sitePhrasing.state} not implemented</h3>

      <ContactInfoFields
        values={values}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
      />

      <TextInputField
        mask={sitePhrasing.referenceMask}
        fieldName={"referenceNumber"}
        fieldLabel={"Reference Number"}
        fieldSubLabel={undefined}
        customFieldInstructions={() => (<AnnualReferenceNumberInstructions />)}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Reference Number"}
        maskGuide={sitePhrasing.referenceMaskGuide}
      />

      <TextInputField
        fieldName={"businessName"}
        fieldLabel={"Complete Business Name"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Complete Business Name"}
      />
    </>
  );
};
